import React, { Fragment, useEffect } from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
//import Clearfix from '../../components/UI/Clearfix/Clearfix';
// Sections for this page
import PonenciaData from '../../components/PonenciaPage/PonenciaData';

import ponenciaPageStyle from '../../assets/jss/coscef/views/ponenciaPageStyle';

const useStyles = makeStyles(ponenciaPageStyle);

const PonenciaPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <PonenciaData {...props} />
      </div>
      <div className={classes.section}></div>
    </Fragment>
  );
};

export default PonenciaPage;
